import React from "react";
import { Icon, IconButton, Tooltip } from "@chakra-ui/react";
import { FiMic } from "react-icons/fi";

const SHADOW = {
  teal: {
    rest: "0 12px 40px -8px rgba(20,184,166,0.55)",
    hover: "0 18px 44px -10px rgba(20,184,166,0.6)",
  },
  blue: {
    rest: "0 12px 40px -8px rgba(59,130,246,0.45)",
    hover: "0 18px 44px -10px rgba(59,130,246,0.55)",
  },
};

/**
 * Large circular mic for tab voice assistants — matches dashboard Voice hub styling.
 */
export function VoiceAssistantMicButton({
  onClick,
  isLoading = false,
  isDisabled = false,
  colorScheme = "teal",
  tooltipLabel = "Uses your browser speech recognition (Chrome / Edge). Sends text to the server.",
  ariaLabel = "Speak with microphone",
  /** Smaller control for dense layouts (e.g. mobile todos). Default is large hub-style mic. */
  compact = false,
}) {
  const key = colorScheme === "blue" ? "blue" : "teal";
  const sh = SHADOW[key];
  const isCompact = compact;

  const btn = (
    <IconButton
      aria-label={ariaLabel}
      icon={
        <Icon
          as={FiMic}
          boxSize={
            isCompact ? { base: 6, sm: 7 } : { base: 12, md: 14 }
          }
        />
      }
      w={isCompact ? { base: "4.25rem", sm: "4.75rem" } : { base: "120px", md: "140px" }}
      h={isCompact ? { base: "4.25rem", sm: "4.75rem" } : { base: "120px", md: "140px" }}
      minW={isCompact ? { base: "4.25rem", sm: "4.75rem" } : { base: "120px", md: "140px" }}
      minH={isCompact ? { base: "4.25rem", sm: "4.75rem" } : { base: "120px", md: "140px" }}
      borderRadius="full"
      colorScheme={colorScheme}
      variant="solid"
      fontSize="4xl"
      boxShadow={sh.rest}
      _hover={{
        transform: "translateY(-2px)",
        boxShadow: sh.hover,
      }}
      _active={{ transform: "translateY(0)" }}
      transition="all 0.2s ease"
      onClick={onClick}
      isLoading={isLoading}
      isDisabled={isDisabled}
    />
  );

  if (!tooltipLabel) return btn;

  return (
    <Tooltip label={tooltipLabel} hasArrow>
      {btn}
    </Tooltip>
  );
}
